import { create } from "zustand";
import { TChatStore, createChatSlice } from "./createChatSlice";

export const useChatStore = create<TChatStore>(createChatSlice);
